// extracted by mini-css-extract-plugin
export default {"wrapperLayout":"MyPosition_wrapperLayout__ekzk+","wrapperSecondSection":"MyPosition_wrapperSecondSection__8pwhX","wrapperFirstSection":"MyPosition_wrapperFirstSection__QMhut"};